import React, { PureComponent } from "react";
import MailList from "../../components/mailList";
import MailHeader from "../../components/mailHeader";

import {
	setSurveyCompleteFlag,
	setMailThreads,
	autoSaveSurveyAnswers
} from "../../actions/init";
import {
	addMailReadFlag,
	addMailStarredFlag,
	removeMailStarredFlag,
	setCurrentMailIndex,
	getTimeData
} from "./../../actions/mail/mailScheduler";
import {
	startTutorial,
	stopTutorial,
	addStepsToTutorial,
	updateStepNumber
} from "./../../actions/tutorial";
import {
	tutorialSequence,
	mailSequence
} from "./../../constants/tutorialSequence";
import { connect } from "react-redux";
import "./../../app.scss";
import orderBy from "lodash/orderBy";

class MailListContainer extends PureComponent {
	componentDidMount() {
		if (
			!this.props.tutorial.isRunning &&
			this.props.match.url.includes("tutorial")
		) {
			startTutorial();
			addStepsToTutorial(tutorialSequence, "first-page");
		}
	}

	isShownAction = actionThread => {
		return actionThread.find(action => action.type === "isShown");
	};

	isPrimaryMailReady = mail => {
		return (
			mail.isPrimary &&
			mail.actionThread &&
			this.isShownAction(mail.actionThread) &&
			mail.type !== "call" &&
			mail.type !== "meeting"
		);
	};

	getMailReadFlag = mail => {
		const { actionThread } = mail;
		return actionThread.some(action => action.type === "mail_read");
	};

	isMailStarred = mail => {
		const { actionThread } = mail;
		return actionThread.some(
			action => action.type === "starred" && action.status === true
		);
	};

	isSentMailPresent = mail => {
		const { actionThread } = mail;
		return actionThread.some(action => action.type === "compose");
	};

	getMailList = () => {
		const { mails, match, mailThreads } = this.props;

		let tempArray = mails.filter(mail => this.isPrimaryMailReady(mail));
		tempArray.map(mail => {
			let thread = mailThreads.find(
				mailThread => mailThread[0] === mail.id
			);
			let timeData = getTimeData();

			if (thread) {
				let lastMail = mails.find(
					threadMail => threadMail.id === thread[thread.length - 1]
				);
				let isLastMailShown = true;
				if (!this.isShownAction(lastMail.actionThread)) {
					lastMail = mails.find(
						threadMail =>
							threadMail.id === thread[thread.length - 2]
					);
					isLastMailShown = false;
				}
				let displayTime = lastMail.receivedAtTime - timeData.timeLeft;
				if (displayTime > 0) {
					mail.displayTime = displayTime;
				} else {
					mail.displayTime = 0;
				}
				mail.isRead = this.getMailReadFlag(lastMail);
				mail.isStarred = this.isMailStarred(lastMail);
				mail.lastMail = lastMail;

				let length = thread.length;
				if (!isLastMailShown) {
					length -= 1;
				}

				if (this.isSentMailPresent(lastMail)) {
					mail.replies = length * 2 - 1;
				} else {
					mail.replies = length * 2 - 2;
				}
			} else {
				let displayTime = mail.receivedAtTime - timeData.timeLeft;
				if (displayTime > 0) {
					mail.displayTime = displayTime;
				} else {
					mail.displayTime = 0;
				}
				mail.isRead = this.getMailReadFlag(mail);
				mail.isStarred = this.isMailStarred(mail);
				mail.lastMail = mail;
				if (this.isSentMailPresent(mail)) {
					mail.replies = 1;
				} else {
					mail.replies = 0;
				}
			}
			return mail;
		});

		let mailArray = orderBy(tempArray, ["displayTime", "id"], ["asc", "desc"]);

		if (match.url === "/mails/starred") {
			return mailArray.filter(
				mail =>
					this.isPrimaryMailReady(mail) && this.isMailStarred(mail)
			);
		} else if (match.url === "/mails/attachments") {
			return mailArray.filter(
				mail => this.isPrimaryMailReady(mail) && mail.attachments
			);
		} else if (match.url === "/mails/sent") {
			return mailArray.filter(
				mail =>
					this.isPrimaryMailReady(mail) &&
					this.isSentMailPresent(mail)
			);
		} else {
			return mailArray
		}
	};

	render() {
		return (
			<MailList
				uiState={this.props.uiState}
				actors={this.props.actors}
				mails={this.props.mails}
				tutorial={this.props.tutorial}
				startTutorial={startTutorial}
				stopTutorial={stopTutorial}
				addStepsToTutorial={addStepsToTutorial}
				updateStepNumber={updateStepNumber}
				mailSequence={mailSequence}
				primaryMails={this.getMailList()}
				addMailReadFlag={addMailReadFlag}
				addMailStarredFlag={addMailStarredFlag}
				setSurveyCompleteFlag={setSurveyCompleteFlag}
				autoSaveSurveyAnswers={autoSaveSurveyAnswers}
				getTimeData={getTimeData}
				removeMailStarredFlag={removeMailStarredFlag}
				setCurrentMailIndex={setCurrentMailIndex}
				setMailThreads={setMailThreads}
			/>
		);
	}
}

const mapStateToProps = state => {
	return {
		mails: state.mails,
		actors: state.actors,
		uiState: state.uiState,
		mailThreads: state.mailThreads,
		callSequence: state.callSequence,
		tutorial: state.tutorial
	};
};

export default connect(
	mapStateToProps,
	{
		setMailThreads,
		addMailReadFlag,
		addMailStarredFlag,
		removeMailStarredFlag,
		setCurrentMailIndex,
		getTimeData
	}
)(MailListContainer);



// WEBPACK FOOTER //
// /src/containers/mailListContainer/MailListContainer.js